"use strict";

var _slicedToArray = require("/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var l = require("react/jsx-runtime"),
  e = require("@vds-tokens/color");
function n(l) {
  return l && l.__esModule ? l : {
    default: l
  };
}
var i = n(require("lz-string"));
exports.deprecatedIconsMap = {
  "closed-captioning-fill": "closed-captioning-filled",
  "tech-phone": "headphones",
  "play-alt": "play-alternate",
  "checkmark-alt": "alternate-checkmark",
  "microphone-alt": "microphone-alternate",
  "stadium-alt": "stadium",
  "more-flexibility": "flexible-three-arrows",
  "even-more-flexibility": "flexible-four-arrows",
  "cloud-alt": "cloud-alternative",
  wifi: "wifi-wireless",
  "white-black-list": "allow-block-list",
  group: "group-family",
  "unified-comms": "unified-communications",
  "close-alt": "close-alternate",
  "nation-wide": "nationwide",
  "turnon-off": "turn-on-off",
  "stop-alt": "stop-alternate",
  "phone-alt": "cell-phone",
  "healthcare-worker": "add-user",
  "star-off": "star"
}, exports.getIconColor = function (l) {
  var n = l.color,
    i = l.surface;
  var t = n;
  return ("dark" !== i || n) && ("dark" !== i || "black" !== n && n !== e.ColorTokens.elements.primary.onlight.value && "Black" !== n) || (t = e.ColorTokens.elements.primary.ondark.value), t;
}, exports.getViewBox = function (l) {
  switch (l) {
    case 0:
      return "0 0 21.6 21.6";
    case 1:
      return "0 0 38 38";
    default:
      return "0 0 21.6000004 21.6000004";
  }
}, exports.mapChildren = function e(n, t) {
  return (null == n ? void 0 : n.length) > 0 && (null == n ? void 0 : n.map(function (n, o) {
    var r, a, c, s, d, f, u, h, p;
    var x = n.a;
    if ("g" === n.n) return l.jsx("g", {
      children: (null === (r = n.c) || void 0 === r ? void 0 : r.length) > 0 && e(n.c, t)
    }, "".concat(n.n).concat(o));
    if (!n.n || "path" === n.n) {
      var _x$style$split, _x$style$split2;
      var _r;
      return x.style && (_x$style$split = x.style.split("fill:"), _x$style$split2 = _slicedToArray(_x$style$split, 1), _r = _x$style$split2[0], _x$style$split), l.jsx("path", {
        d: i.default.decompressFromBase64(x.d),
        stroke: "none",
        fill: _r || (x.fill ? x.fill : t),
        children: (null === (a = n.c) || void 0 === a ? void 0 : a.length) > 0 && e(n.c, t)
      }, "".concat(n.n).concat(o));
    }
    return "circle" === n.n ? l.jsx("circle", {
      id: x.id,
      cx: x.cx,
      cy: x.cy,
      r: x.r,
      opacity: x.opacity,
      stroke: "none",
      fill: x.fill ? x.fill : t,
      children: (null === (c = n.c) || void 0 === c ? void 0 : c.length) > 0 && e(n.c, t)
    }, "".concat(n.n).concat(o)) : "rect" === n.n ? l.jsx("rect", {
      x: x.x,
      y: x.y,
      ry: x.ry,
      rx: x.rx,
      transform: x.transform,
      width: x.width,
      height: x.height,
      stroke: "none",
      fill: x.fill ? x.fill : t,
      children: (null === (s = n.c) || void 0 === s ? void 0 : s.length) > 0 && e(n.c, t)
    }, "".concat(n.n).concat(o)) : "polyline" === n.n ? l.jsx("polyline", {
      points: x.points,
      stroke: "none",
      fill: x.fill ? x.fill : t,
      children: (null === (d = n.c) || void 0 === d ? void 0 : d.length) > 0 && e(n.c, t)
    }, "".concat(n.n).concat(o)) : "line" === n.n ? l.jsx("line", {
      x1: x.x1,
      x2: x.x2,
      y1: x.y1,
      y2: x.y2,
      stroke: "none",
      fill: x.fill ? x.fill : t,
      children: (null === (f = n.c) || void 0 === f ? void 0 : f.length) > 0 && e(n.c, t)
    }, "".concat(n.n).concat(o)) : "polygon" === n.n ? l.jsx("polygon", {
      points: i.default.decompressFromBase64(x.points),
      stroke: "none",
      fill: x.fill ? x.fill : t,
      children: (null === (u = n.c) || void 0 === u ? void 0 : u.length) > 0 && e(n.c, t)
    }, "".concat(n.n).concat(o)) : "linearGradient" === n.n ? l.jsx("linearGradient", {
      id: x.id,
      gradientUnits: x.gradientUnits,
      x1: x.x1,
      y1: x.y1,
      x2: x.x2,
      y2: x.y2,
      gradientTransform: x.gradientTransform,
      children: (null === (h = n.c) || void 0 === h ? void 0 : h.length) > 0 && e(n.c, t)
    }, "".concat(n.n).concat(o)) : "stop" === n.n ? l.jsx("stop", {
      offset: x.offset,
      stopColor: x["stop-color"],
      children: (null === (p = n.c) || void 0 === p ? void 0 : p.length) > 0 && e(n.c, t)
    }, "".concat(n.n).concat(o)) : null;
  }).filter(function (l) {
    return null !== l;
  }));
};